<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 260px">
      <div class="left-top" @click="onAdd({})">
        <div class="flex-1 font-16-30313a">材料分类</div>
        <div class="tip-20-bg-30313a">
          <i class="el-icon-plus font-bold"></i>
        </div>
      </div>
      <div class="flex-1 h-0" v-if="classifyList && classifyList.length">
        <cate-menu :menu-data="classifyList" :permission="permission" :cateType="1" @on-edit="onEditClassify"
          @on-delete="onDeleteClassify" @on-add="onAdd" @on-choose="onChooseMenu" :choose-id="chooseMenuId"
          :special-item="1"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
      <div class="flex content-top mb-10">
        <div class="flex-1 h-100 flex align-center pl-5 mr-10 bg-ff">
          <div class="tab-item active">
            <span class="bg-4-46b8b0"></span>
            {{ currentClassify.name }}
          </div>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input class="border-none" type="text" placeholder="材料名称/编码/规格/型号" v-model="keywords" clearable
              @keyup.enter.native="onSearch"></el-input>
          </div>
          <button class="btn-30-bg-46b8b0" @click="onSearch()">搜索</button>
        </div>
      </div>
      <!-- <div class="hr mb-10"></div> -->
      <div class="flex mb-10">
        <div class="flex align-center flex-1 mr-10" style="overflow-x: hidden">
          <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 90px;" @click="onAddMaterial">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            新增材料
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 90px;" @click="batchSetEnable(1)"
            v-if="permission.includes('batchEnableMaterial')">
            <div class="mr-5">
              <i class="el-icon-video-play" style="color: #46b8b0; font-size: 14px"></i>
            </div>
            批量发布
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 90px;" @click="batchSetEnable(-1)"
            v-if="permission.includes('batchCancelMaterial')">
            <div class="mr-5">
              <i class="el-icon-remove" style="color: #46b8b0; font-size: 14px"></i>
            </div>
            批量取消
          </div>
          <div class="btn-24-bg-ff flex align-center mr-10" style="min-width: 115px;" @click="setMaterialParam">
            <img src="/static/images/customer/shejishi.png" class="icon-14 mr-5" alt="">
            修改材料参数
          </div>
          <div class="btn-24-bg-ff flex align-center mr-10" style="min-width: 115px;" @click="setMaterialPrice">
            <img src="/static/images/customer/dollar-huang.png" class="icon-14 mr-5" alt="">
            材料价格定义
          </div>
          <div class="btn-24-bg-ff flex align-center mr-5" style="min-width: 106px;" @click="chooseSupply">
            <div class="mr-5">
              <i class="el-icon-s-shop" style="color: #46b8b0; font-size: 14px"></i>
            </div>
            选择供应商
          </div>
          <div class="btn-24-bg-ff flex align-center mr-10" style="min-width: 90px;" @click="setDefaultItem">
            <img src="/static/images/customer/feidanyubao.png" class="icon-14 mr-5" alt="">
            默认特项
          </div>
          <div class="btn-24-bg-ff flex align-center mr-10" style="min-width: 90px;" @click="setDefaultCode">
            <div class="mr-5">
              <i class="el-icon-s-order" style="color: #46b8b0; font-size: 14px"></i>
            </div>
            默认编码
          </div>
          <div class="btn-24-bd-e2-bg-ff flex align-center" style="min-width: 70px;" @click="onDeleteMaterial"
            v-if="permission.includes('deleteMaterial')">
            <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
            删除
          </div>
        </div>
        <move-horizon move-dom="right" :min="50" move-id="smallMoveRight" size="small"></move-horizon>
        <div style="overflow: hidden; margin-left: 10px; width: 250px" class="flex" id="smallMoveRight">
          <div class="btn-24-bd-e2 mr-5 flex align-center" style="min-width: 66px;">
            <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
            <el-upload multiple name="file" :httpRequest="httpRequestImport" :action="upImport" :show-file-list="false">
              <div style="margin: 10px auto 10px auto">导入</div>
            </el-upload>
          </div>
          <div class="btn-24-bd-e2 flex align-center mr-5" style="min-width: 66px;" @click="materialExport">
            <img src="/static/images/daochu.png" class="icon-14 mr-5" alt="">
            导出
          </div>
          <div class="btn-24-bd-e2 flex align-center" style="min-width: 106px;" @click="isQrcodeShow = true">
            <img src="/static/images/qrcode.png" class="icon-14 mr-5" alt="">
            导出二维码
          </div>
        </div>
      </div>
      <div class="hr"></div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0 no-checked-row-color" v-if="columnData.length > 0">
          <erp-table ref="erpTable" @change-current-row="changeCurrentRow" :table-data="tableData" :loading="loading"
            :is-edit="isEdit" :column-data="columnData" @on-switch="onChangeStatus" @on-modify="onModifyMaterialInRow"
            modify-method="on-modify" @on-change-modify="onChangeModify" @on-change-price="onChangePrice"
            @on-change-inventory="onChangeInventory"></erp-table>
        </div>
        <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump">
        </Pagination>
      </div>
      <move-vertical :max="560" :min="150" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 220px">
        <div class="flex align-center">
          <div class="flex align-center mr-20 cursor pb-5 relative" :class="{ 'tabActive': index === smallTabIndex }"
            v-for="(item, index) in smallTab" :key="index" @click="switchSmallTab(index)">
            <div class="mr-5" :class="index === smallTabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
            <div class="font-bold" :class="index === smallTabIndex ? 'font-16-46b8b0' : 'font-16-30313a'">{{ item }}</div>
          </div>
        </div>
        <div class="hr mb-10"></div>
        <div class="overflow-y flex-1">
          <div class="text-left h-100" v-if="smallTabIndex === 0">
            <div class="flex flex-wrap w-100" v-if="currentRow.id">
              <div class="info-item">
                <div>材料名称：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('name')"
                  v-model="currentRow.name"></el-input>
              </div>
              <div class="info-item">
                <div>材料编码：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('code')"
                  v-model="currentRow.code"></el-input>
              </div>
              <div class="info-item">
                <div>品类：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('category')"
                  v-model="currentRow.category"></el-input>
              </div>
              <div class="info-item">
                <div>品牌：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('brand')"
                  v-model="currentRow.brand"></el-input>
              </div>
              <div class="info-item">
                <div>色号：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('colorNumber')"
                  v-model="currentRow.colorNumber"></el-input>
              </div>
              <div class="info-item">
                <div>规格：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('standard')"
                  v-model="currentRow.standard"></el-input>
              </div>
              <div class="info-item">
                <div>型号：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('model')"
                  v-model="currentRow.model"></el-input>
              </div>
              <div class="info-item">
                <div>单位：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('salesUnit')"
                  v-model="currentRow.salesUnit"></el-input>
              </div>
              <!--<div class="info-item">-->
              <!--<div>采购单位：</div>-->
              <!--<el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('purchasingUnit')" v-model="currentRow.purchasingUnit"></el-input>-->
              <!--</div>-->
              <div class="info-item">
                <div>供应商：</div>
                <el-input placeholder="请输入" class="flex-1 no-style-input" @blur="onModifyMaterial('businessName')"
                  v-model="currentRow.businessName"></el-input>
              </div>
            </div>
          </div>
          <div class="text-left font-12-30313a h-100" v-if="smallTabIndex === 1">
            <el-input type="textarea" v-if="currentRow.id" :rows="5" v-model="currentRow.description"
              @blur="onModifyMaterial('description')"></el-input>
          </div>
          <div class="text-left flex flex-wrap" v-if="smallTabIndex === 2">
            <div v-for="(item, index) in currentRow.materialPhotoList" :key="index"
              class="mr-10 p-relative flex-column mb-10">
              <el-image style="width: 90px; height: 90px" :src="item.completePath" :preview-src-list="srcList"
                fit="cover"></el-image>
              <div class="info-item" style="width: 90px">
                <el-input class="no-style-input font-12-30313a text-center" v-model="item.name" @blur="onModifyImg(item)"
                  placeholder="请输入"></el-input>
              </div>
              <i class="el-icon-error delete-img" @click.stop="onRemoveImg(index)"></i>
            </div>
            <el-upload v-if="currentRow.id" class="small-upload" list-type="picture-card" multiple name="file"
              :httpRequest="httpRequestImg" :action="upload" :show-file-list="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="text-left flex h-100" v-if="smallTabIndex === 3">
            <el-card :body-style="{ padding: '10px', display: 'flex', position: 'relative' }" v-if="currentRow.qrPath">
              <div class="h-100 flex" @click="toBigImg">
                <img :src="currentRow.qrPath" style="width: 70px; height: 70px; margin-right: 10px">
                <div class="flex-column justify-center">
                  <span class="font-12-30313a">二维码编号{{ currentRow.qrCode || '' }}</span>
                  <div class="font-13-46b8b0">查看大图</div>
                </div>
              </div>
              <i class="el-icon-zoom-in"></i>
            </el-card>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" title="二维码详情" width="640px"
      :visible.sync="isErcodeShow">
      <div class="flex" style="padding: 30px 40px 40px;">
        <img :src="currentRow.qrPath" style="width: 240px;height: 240px; margin-right: 40px;" alt="">
        <div class="flex-1">
          <div style="padding: 28px 0 36px; border-bottom: 1px dashed #e2e2e2; margin-bottom: 36px"
            class="font-22-30313a text-left">
            二维码编号{{ currentRow.qrCode || '' }}
          </div>
          <div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">材料名称：</div>
              <div class="font-12-30313a">{{ currentRow.name }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">材料编码：</div>
              <div class="font-12-30313a">{{ currentRow.code }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;类：</div>
              <div class="font-12-30313a">{{ currentRow.category }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">品&nbsp;&nbsp;牌&nbsp;&nbsp;名：</div>
              <div class="font-12-30313a">{{ currentRow.brand }}</div>
            </div>
            <div class="flex align-center mb-5">
              <div class="font-12-b9b9b9">供&nbsp;&nbsp;应&nbsp;&nbsp;商：</div>
              <div class="font-12-30313a">{{ currentRow.brand }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" title="修改材料参数" width="526px"
      :visible.sync="isModifyClassifyShow">
      <div class="flex" style="height: 172px">
        <div class="modify-dialog-left">
          <div class="modify-item" v-for="(item, index) in modifyArr" :key="index"
            :class="{ 'active': index === modifyIndex }" @click="modifyIndex = index">
            <span class="text-left p-relative">{{ item }}</span>
          </div>
        </div>
        <div class="flex-1 bg-f3f4f7 h-100 flex-column plr-20">
          <div class="flex align-center border-b-dashed-e2 text-left mb-20 w-100 mt-20" style="padding-bottom: 10px;">
            <el-checkbox class="font-12-ff5555 cb-16-ff5555" v-model="isModifyAll">所在分类下全部修改</el-checkbox>
          </div>
          <div v-if="modifyIndex === 0">
            <div class="flex align-center mb-10 border-b-dashed-e2" style="padding-bottom: 20px;">
              <div class="font-12-30313a">批量修改：</div>
              <el-select class="flex-1" v-model="modifyItemIndex" placeholder="请选择">
                <el-option v-for="(item, index) in columnData" v-if="item.editRender" :key="item.field"
                  :label="item.title" :value="index">
                </el-option>
              </el-select>
              <img src="/static/images/xiugaiwei.png" style="width: 54px; margin: 0 5px" alt="">
              <el-input class="flex-1" v-model="modifyItemValue"></el-input>
            </div>
            <div class="font-12-30313a text-left align-center mb-8">
              <i class="el-icon-warning font-12-ff5555 mr-5"></i>
              提示：你正将选中材料的 <span style="color: #ff5555">{{ columnData[modifyItemIndex].title }}</span> 批量修改为 <span
                style="color: #ff5555">{{ modifyItemValue }}</span>
            </div>
          </div>
          <div v-if="modifyIndex === 1">
            <div class="flex align-center mb-10 border-b-dashed-e2" style="padding-bottom: 20px">
              <el-select class="flex-1" v-model="priceIndex0" placeholder="请选择">
                <el-option v-for="(item, index) in priceList" :key="item.priceField" :label="item.name" :value="index">
                </el-option>
              </el-select>
              <div class="pl-5 pr-5 font-12-ff5555">=</div>
              <el-select style="width: 110px" class="select-prepend" v-model="priceIndex1" placeholder="请选择">
                <el-option v-for="(item, index) in priceList" :key="item.priceField" :label="item.name" :value="index">
                </el-option>
              </el-select>
              <el-select style="width: 50px" class="font-12-ff5555 select-prepend select-append" v-model="symbol"
                placeholder="请选择">
                <el-option v-for="item in calcOption" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
              <el-input class="input-with-select" style="width: 70px" v-model="specificPrice"
                placeholder="请输入"></el-input>
            </div>
            <div class="font-12-30313a text-left flex mb-8">
              <i class="el-icon-warning font-12-ff5555 mr-5" style="margin-top: 3px;"></i>
              <div class="flex-1">
                <div>你正将选中材料的计价方式批量修改为：</div>
                <div style="color: #ff5555" class="font-bold">{{ priceList[priceIndex0].name }} =
                  {{ priceList[priceIndex1].name }} {{ symbol }} {{ specificPrice }}</div>
              </div>
            </div>
          </div>
          <div v-if="modifyIndex === 2" class="flex align-center">
            <el-checkbox label="修改" class="mr-40" v-model="isModified" :true-label="1" :false-label="-1"></el-checkbox>
            <el-checkbox label="报价" class="mr-40" v-model="priceFlag" :true-label="1" :false-label="-1"></el-checkbox>
            <el-checkbox label="库存" v-model="inventoryFlag" :true-label="1" :false-label="-1"></el-checkbox>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="onResetParams">重置</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitParams">确定</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" :title="mOrA + '材料分类'"
      width="378px" :visible.sync="isAddClassifyShow">
      <div style="padding: 10px 20px 20px">
        <div class="bg-ff font-12-ff5555 text-left align-center mb-8">
          <i class="el-icon-warning mr-5"></i>
          提示：标有 * 的为必填项！
        </div>
        <div class="flex align-center p-relative mb-10">
          <div class="require-tip">*</div>
          <div class="font-12-30313a mr-5">分类名称：</div>
          <el-input class="flex-1" v-model="classifyInfo.name" placeholder="请输入"></el-input>
        </div>
        <div class="flex align-center p-relative mb-10">
          <div class="font-12-30313a mr-5">分类编码：</div>
          <el-input class="flex-1" v-model="classifyInfo.code" placeholder="请输入"></el-input>
        </div>
        <div class="flex align-center p-relative mb-20">
          <div class="require-tip">*</div>
          <div class="font-12-30313a mr-5">分类特项：</div>
          <el-input class="flex-1" v-model="classifyInfo.specialItem" placeholder="请输入"></el-input>
        </div>
        <div class="flex text-left">
          <el-checkbox label="启用" v-model="classifyInfo.status" :true-label="1" :false-label="-1"
            class="mr-20"></el-checkbox>
          <el-checkbox label="报价" v-model="classifyInfo.priceFlag" :true-label="1" :false-label="-1"
            class="mr-20"></el-checkbox>
          <el-checkbox label="库存" v-model="classifyInfo.inventoryFlag" :true-label="1" :false-label="-2"
            class="mr-20"></el-checkbox>
          <el-checkbox label="修改" v-model="classifyInfo.isModified" :true-label="1" :false-label="-1"
            class="mr-20"></el-checkbox>
          <el-checkbox label="显示" v-model="classifyInfo.isBusiness" :true-label="1" :false-label="-1"
            class="mr-20"></el-checkbox>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="resetClassify">重置</div>
        <div class="btn-30-bg-46b8b0-s" @click="submitClassify">确定</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" title="导出二维码" width="1215px"
      :visible.sync="isQrcodeShow">
      <div class="flex-column ptb-10 plr-20" style="height: 473px;">
        <div class="h-100">
          <el-scrollbar class="h-100 w-100 hide-x">
            <div>
              <div class="font-12-30313a text-left flex mb-8">
                <i class="el-icon-warning font-12-ff5555 mr-5" style="margin-top: 3px;"></i>
                提示：您正在批量导出所选材料的二维码，导出格式默认为word格式，请知悉！
              </div>
              <div class="flex flex-wrap flex-1 h-0" style="margin: 0 -10px">
                <div class="qr-item" v-for="(item, index) in tableData" :key="index">
                  <img :src="item.qrPath" class="mr-20" style="width: 127px; height: 127px" alt="">
                  <div class="flex-1 text-left">
                    <div class="font-14-30313a text-left pb-15 border-b-dashed-e2" style="margin-bottom: 15px">
                      二维码编号{{ item.qrCode }}</div>
                    <div class="flex align-center">
                      <div class="font-12-b9b9b9">材料名称：</div>
                      <div class="font-12-30313a flex-1">{{ item.name }}</div>
                    </div>
                    <div class="flex align-center">
                      <div class="font-12-b9b9b9">材料编码：</div>
                      <div class="font-12-30313a flex-1">{{ item.code }}</div>
                    </div>
                    <div class="flex align-center">
                      <div class="font-12-b9b9b9 flex">
                        <div class="text-justify" style="width: 48px; height: 16px">品类</div>：
                      </div>
                      <div class="font-12-30313a flex-1">{{ item.category }}</div>
                    </div>
                    <div class="flex align-center">
                      <div class="font-12-b9b9b9 flex">
                        <div class="text-justify" style="width: 48px; height: 16px">品牌名</div>：
                      </div>
                      <div class="font-12-30313a flex-1">{{ item.brand }}</div>
                    </div>
                    <div class="flex align-center">
                      <div class="font-12-b9b9b9 flex">
                        <div class="text-justify" style="width: 48px; height: 16px">供应商</div>：
                      </div>
                      <div class="font-12-30313a flex-1">{{ item.businessName }}</div>
                    </div>
                  </div>
                  <i class="el-icon-error delete-img" @click.stop="onRemoveQrcode(index)"></i>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-bg-46b8b0-s" @click="submitQrcode">确定</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" title="材料价格定义" width="543px"
      :visible.sync="isPriceDefineShow">
      <div style="height: 415px; padding-bottom: 20px;padding-top: 10px;" class="plr-20 flex-column">
        <div class="font-12-ff5555 text-left flex mb-8">
          <i class="el-icon-warning font-12-ff5555 mr-5" style="margin-top: 3px;"></i>
          提示：您正在为当前选中的材料进行价格定义
        </div>
        <div class="flex align-center mb-10">
          <div class="btn-24-bd-e2-bg-ff flex align-center mr-5" @click="onAddPrice">
            <img src="/static/images/customer/chubeikehu.png" class="icon-14 mr-5" alt="">
            新增
          </div>
          <div class="btn-24-bd-e2-bg-ff flex align-center" @click="onDeletePrice">
            <img src="/static/images/shanchu.png" class="icon-14 mr-5" alt="">
            删除
          </div>
        </div>
        <div class="flex-1">
          <div class="h-100 overflow-y">
            <erp-table ref="priceTable" :table-data="priceData" :is-edit="true" :column-data="priceColumn"
              @on-switch="onChangePriceStatus" @on-modify="onModifyPrice" modify-method="on-modify"></erp-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="1215px" title="选择供应商"
      :visible.sync="isSupplierShow">
      <choose-supplier @click-supplier="onClickSupplier"></choose-supplier>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
import ChooseSupplier from '../../components/ChooseSupplier'
import axiosx from 'axios'

export default {
  name: 'materialDefine',
  components: { Pagination, MoveHorizon, CateMenu, ErpTable, MoveVertical, ChooseSupplier },
  data () {
    return {
      upImport: `${this.$store.state.API_URL_9010}/budget/import`,
      upload: `${this.$store.state.API_URL_9009}/fileUpload/uploadFile`,
      keywords: '',
      page: 1,
      limit: 25,
      pageSize: 0, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 25, // 当前页条数
      total: 0, // 总条数
      classifyList: [],
      isClassifyShow: true,
      modifyItemIndex: 5,
      modifyItemValue: '',
      isEdit: true,
      columnData: [
        {
          type: 'selection',
          width: '40'
        },
        {
          field: 'id',
          title: 'id',
          width: '40'
        },
        {
          field: 'switch',
          title: '发布',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'status',
            methodName: 'on-switch',
            type: 'switch',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'isModified',
          title: '修改',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'isModified',
            methodName: 'on-change-modify',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'priceFlag',
          title: '报价',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'priceFlag',
            methodName: 'on-change-price',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'inventoryFlag',
          title: '库存',
          width: '60',
          isDefine: true,
          child: [{
            title: '是',
            key: 'inventoryFlag',
            methodName: 'on-change-inventory',
            type: 'radio',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'specialItem',
          title: '特项',
          width: '55',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'code',
          title: '材料编码',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'brand',
          title: '品牌名',
          minWidth: '120',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'name',
          title: '材料名称',
          minWidth: '200',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'category',
          title: '品类',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'model',
          title: '型号',
          width: '120',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'standard',
          title: '规格',
          width: '80',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'colorNumber',
          title: '色号',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'salesUnit',
          title: '单位',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'businessName',
          title: '供应商',
          width: '150'
        }, {
          field: 'costPrice',
          title: '成本价',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'weightedCostPrice',
          title: '加权成本价',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'customerPrice',
          title: '客户价',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'modifierName',
          title: '最后修改人',
          width: '100'
        }, {
          field: 'modifyTime',
          title: '最后修改时间',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'positiveRebate',
          title: '正价返点',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'discountRebate',
          title: '优惠价返点',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'specialRebate',
          title: '特价返点',
          width: '100',
          editRender: {
            name: 'input'
          }
        }
      ],
      chooseMenuId: 0,
      currentClassify: {},
      loading: false,
      isModifyAll: false,
      isQrcodeShow: false,
      isSupplierShow: false,
      tableData: [],
      srcList: [],
      smallTab: ['材料信息', '材料说明', '材料图片', '二维码'],
      smallTabIndex: 0,
      currentRow: {},
      value: '选项1',
      isErcodeShow: false,
      isAddClassifyShow: false,
      isModifyClassifyShow: false,
      isPriceDefineShow: false,
      classifyInfo: {},
      modifyIndex: 0,
      modifyArr: ['材料信息修改', '材料价格修改', '状态修改'],
      symbol: '+',
      specificPrice: 0,
      calcOption: ['+', '-'],
      mOrA: '新增',
      priceList: [],
      priceIndex0: 0,
      priceIndex1: 0,
      isModified: -1,
      priceFlag: -1,
      inventoryFlag: -1,
      priceData: [],
      priceColumn: [
        {
          type: 'selection',
          width: '40'
        },
        {
          field: 'switch',
          title: '启用',
          width: '45',
          isDefine: true,
          child: [{
            title: '是',
            key: 'status',
            methodName: 'on-switch',
            type: 'switch',
            activeValue: 1,
            inactiveValue: -1
          }]
        },
        {
          field: 'name',
          title: '价格名称',
          width: '92',
          editRender: {
            name: 'input'
          }
        },
        {
          field: 'customerPriceName',
          title: '价格',
          width: '152',
          editType: 'select',
          editRender: {
            name: 'select'
          }
        },
        {
          field: 'costPriceName',
          title: '成本价',
          width: '152',
          editType: 'select',
          editRender: {
            name: 'select'
          }
        }
      ],
      permission: []
    }
  },
  created () {
    this.getPermission()
    this.getColumnTitle()
    this.getPriceData()
    this.getClassify(true)
    this.axios.post('materialPrice/getPriceList').then(res => {
      if (res.data.success) {
        for (let i = 0; i < res.data.data.length; i++) {
          res.data.data[i].value = i
          res.data.data[i].label = res.data.data[i].name
        }
        this.priceList = res.data.data
        this.priceColumn[3].editRender.options = this.priceList
        this.priceColumn[4].editRender.options = this.priceList
      } else {
        this.$message({
          message: res.data.msg,
          type: 'error',
          offset: 400
        })
      }
    })
  },
  mounted () { },
  methods: {
    getPermission () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/permissionStr`, {
        parent: 'materialDefine',
        parentGroup: 'materialDefine'
      }).then(res => {
        if (res.data.success) {
          this.permission = res.data.data.split(',')
        }
      })
    },
    httpRequestImport (e) {
      let formData = new FormData()
      formData.append('file', e.file)
      formData.append('classifyId', this.currentClassify.id)
      this.axios.post(`${this.$store.state.API_URL_9010}/material/import`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.$message({
            message: onloadRes.data.msg,
            type: 'success'
          })
          this.getMaterial()
        } else {
          this.$message({
            message: onloadRes.data.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message.error('导入失败！')
      })
    },
    // 导出
    materialExport () {
      window.location.href = this.$store.state.API_URL_9010 + '/material/exportExcelMaterial?classifyId=' + this.currentClassify.id
    },
    onClickSupplier (data) {
      let materialArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      for (let i = 0; i < materialArr.length; i++) {
        idArr.push(materialArr[i].id)
      }
      let params = {
        ids: idArr.join(','),
        businessId: data.id,
        businessName: data.name
      }
      this.modifyMaterialByParam(params)
    },
    onDeletePrice () {
      let priceArr = this.$refs.priceTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < priceArr.length; i++) {
        idArr.push(priceArr[i].id)
        nameArr.push(priceArr[i].name)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('materialPrice/deleteByIds', that.qs.stringify({ ids: idArr.join(',') })).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            this.$refs.priceTable.setAllSelection(false)
            that.getPriceData()
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onModifyPrice (row, column, colName) {
      let params = null
      if (colName === 'name') {
        params = {
          id: row.id,
          name: row.name
        }
      } else {
        let key = colName.replace('Name', 'Field')
        params = {
          id: row.id,
          [colName]: this.priceList[row[colName]].name,
          [key]: this.priceList[row[colName]].priceField
        }
      }
      this.submitModifyPrice(params)
    },
    onChangePriceStatus (row) {
      let params = {
        id: row.id,
        status: row.status
      }
      this.submitModifyPrice(params)
    },
    submitModifyPrice (params) {
      this.axios.post('materialPrice/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功！')
          this.getPriceData()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getColumnTitle () {
      // let columnData = [].concat(this.columnData)
      this.axios.post('materialPrice/getPriceField', { companyId: this.$store.state.companyId }).then(res => {
        if (res.data.success) {
          for (let i = 0; i < res.data.data.length; i++) {
            this.columnData.push({
              field: res.data.data[i].priceField,
              title: res.data.data[i].name,
              width: '100',
              editRender: {
                name: 'input'
              }
            })
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
        // this.columnData = columnData
      })
    },
    getPriceData () {
      this.axios.post('materialPrice/list', { companyId: this.$store.state.companyId }).then(res => {
        if (res.data.success) {
          this.priceData = res.data.data
          for (let i = 0; i < this.priceData.length; i++) {
            if (this.priceData[i].status === 1) {
              this.priceData[i].unEditable = 'ALL'
              this.isEdit = false
            }
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAddPrice () {
      this.axios.post('materialPrice/save', { companyId: this.$store.state.companyId, status: -1 }).then(res => {
        if (res.data.success) {
          this.$refs.priceTable.insertAt(res.data.data, this.priceData[0], 'name')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    submitQrcode: function () {
      let that = this
      axiosx({
        method: 'get',
        url: 'http://47.110.234.141:9010/material/exportMaterialQrCode',
        responseType: 'blob',
        headers: {
          'type': 'web_emp',
          'token': that.$store.state.token
        },
        params: { classifyId: that.currentClassify.id }
      }).then(res => {
        if (res.data.type === 'application/json') {
        } else {
          // 假设 data 是返回来的二进制数据
          const data = res.data
          const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }))
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', '二维码.doc')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      })
    },
    onRemoveQrcode () { },
    setDefaultCode () {
      let that = this
      this.$confirm(`是否批量修改默认编码？`, '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('material/resetCode', { classifyId: that.currentClassify.id }).then(res => {
          if (res.data.success) {
            this.$message.success('设置成功')
            this.getMaterial(true)
          } else {
            this.$message({
              type: 'error',
              message: '已取消操作',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    setDefaultItem () {
      let materialArr = this.$refs.erpTable.getSelectEvent()
      if (!materialArr.length) {
        this.$message({
          message: `请先选择要设置的材料`,
          type: 'warning'
        })
      } else {
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < materialArr.length; i++) {
          idArr.push(materialArr[i].id)
          nameArr.push(materialArr[i].name)
        }
        this.$confirm(`是否将“${nameArr.join('、')}”批量修改为默认特项？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(','),
            specialItem: that.currentClassify.specialItem
          }
          that.modifyMaterialByParam(params)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    chooseSupply () {
      let materialArr = this.$refs.erpTable.getSelectEvent()
      if (!materialArr.length) {
        this.$message({
          message: `请先选择要修改的材料`,
          type: 'warning'
        })
      } else {
        this.isSupplierShow = true
      }
    },
    setMaterialPrice () {
      // let materialArr = this.$refs.erpTable.getSelectEvent()
      // if (!materialArr.length) {
      //   this.$message({
      //     message: `请先选择要修改的材料`,
      //     type: 'warning'
      //   })
      // } else {
      this.isPriceDefineShow = true
      // }
    },
    submitParams () {
      let materialArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < materialArr.length; i++) {
        idArr.push(materialArr[i].id)
        nameArr.push(materialArr[i].name)
      }
      let params = null
      switch (this.modifyIndex) {
        case 0:
          params = {
            [this.columnData[this.modifyItemIndex].field]: this.modifyItemValue
          }
          break
        case 1:
          params = {
            targetPrice: this.priceList[this.priceIndex0].priceField,
            sourcePrice: this.priceList[this.priceIndex1].priceField,
            symbol: this.symbol,
            specificPrice: this.specificPrice
          }
          break
        case 2:
          params = {
            isModified: this.isModified,
            priceFlag: this.priceFlag,
            inventoryFlag: this.inventoryFlag
          }
      }
      if (this.isModifyAll) {
        params.classifyId = this.chooseMenuId
      } else {
        params.ids = idArr.join(',')
      }
      that.modifyMaterialByParam(params)
    },
    onResetParams () {
      this.isModifyAll = false
      switch (this.modifyIndex) {
        case 0:
          this.modifyItemIndex = 5
          this.modifyItemValue = ''
          break
        case 1:
          this.priceIndex0 = 0
          this.priceIndex1 = 0
          this.symbol = '+'
          this.specificPrice = 0
          break
        case 2:
          this.inventoryFlag = -1
          this.priceFlag = -1
          this.isModified = -1
      }
    },
    setMaterialParam () {
      let materialArr = this.$refs.erpTable.getSelectEvent()
      if (!materialArr.length) {
        this.$message({
          message: `请先选择要修改的材料`,
          type: 'warning'
        })
      } else {
        this.isModifyClassifyShow = true
      }
    },
    batchSetEnable (status) {
      let materialArr = this.$refs.erpTable.getSelectEvent()
      if (!materialArr.length) {
        // this.$message({
        //   message: `请先选择要设置的材料`,
        //   type: 'warning'
        // })
        let that = this
        this.$confirm(`是否批量${status === -1 ? '取消' : ''}启用？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            classifyId: this.currentClassify.id,
            status
          }
          that.modifyMaterialByParam(params)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      } else {
        let idArr = []
        let nameArr = []
        let that = this
        for (let i = 0; i < materialArr.length; i++) {
          idArr.push(materialArr[i].id)
          nameArr.push(materialArr[i].name)
        }
        this.$confirm(`是否将${nameArr.join('、')}批量${status === -1 ? '取消' : ''}启用？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            ids: idArr.join(','),
            status
          }
          that.modifyMaterialByParam(params)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    modifyMaterialByParam (params) {
      this.axios.post('material/modify', params).then(res => {
        if (res.data.success) {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.getMaterial(false)
          this.isModifyAll = false
          this.isModifyClassifyShow = false
          this.isSupplierShow = false
          this.$refs.erpTable.setAllSelection(false)
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onAddMaterial () {
      let params = {
        priceFlag: this.currentClassify.priceFlag,
        inventoryFlag: this.currentClassify.inventoryFlag,
        classifyId: this.currentClassify.id,
        code: this.currentClassify.code,
        specialItem: this.currentClassify.specialItem
      }
      this.axios.post('material/save', params).then(res => {
        if (res.data.success) {
          this.$refs.erpTable.insertAt(res.data.data, this.tableData[0], 'name')
          this.total++
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onModifyMaterialInRow (row, column, colName) {
      this.onModifyMaterial(colName, row, true)
    },
    onChangeInventory (row) {
      this.onModifyMaterial('inventoryFlag', row, true)
    },
    onChangeModify (row) {
      this.onModifyMaterial('isModified', row, true)
    },
    onChangePrice (row) {
      this.onModifyMaterial('priceFlag', row, true)
    },
    onChangeStatus (row) {
      if (this.permission.includes('enableMaterial')) {
        this.onModifyMaterial('status', row, false, 1)
      } else {
        this.getMaterial(false)
        this.$message({
          type: 'wraning',
          message: '您没有操作权限!'
        })
      }
    },
    onDeleteClassify (menu) {
      let that = this
      this.$confirm('此操作将永久删除该类别, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('materialClassify/deleteById', that.qs.stringify({ id: menu.id })).then(res => {
          if (res.data.success) {
            this.Utils.updateList(this.classifyList, 2, { id: res.data.data })
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            that.$message({
              type: 'error',
              message: res.data.msg,
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onEditClassify (menu) {
      this.mOrA = '修改'
      this.isAddClassifyShow = true
      this.classifyInfo = {
        ...menu
      }
    },
    submitClassify () {
      if (!this.classifyInfo.name || !this.classifyInfo.specialItem) {
        this.$message.warning('请将必填项补充完整')
      } else {
        let url = 'materialClassify/save'
        let type = 0
        if (this.mOrA === '修改') {
          url = 'materialClassify/modify'
          type = 1
        }
        // let params = {
        //   id: this.classifyInfo.id,
        //   inventoryFlag: this.classifyInfo.inventoryFlag
        // }
        this.axios.post(url, this.classifyInfo).then(res => {
          if (res.data.success) {
            this.isAddClassifyShow = false
            this.$message.success(this.mOrA + '成功')
            this.Utils.updateList(this.classifyList, type, res.data.data)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
    },
    resetClassify () {
      this.classifyInfo = {
        ...this.classifyInfo,
        name: '',
        'specialItem': '',
        'code': '',
        'priceFlag': -1,
        'inventoryFlag': -1,
        'isModified': -1,
        status: -1
      }
    },
    onAdd (menu) {
      this.mOrA = '添加'
      this.isAddClassifyShow = true
      this.classifyInfo = {
        companyId: this.$store.state.companyId,
        name: '',
        'specialItem': '',
        'code': '',
        'priceFlag': -1,
        'inventoryFlag': -1,
        'isModified': -1,
        status: -1
      }
      if (menu.id) {
        this.classifyInfo.path = menu.path + ',' + menu.id
        this.classifyInfo.parentId = menu.id
      }
    },
    onModifyImg (img) {
      let params = {
        id: img.id,
        name: img.name
      }
      this.axios.post('materialPhoto/modify', params).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功！')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onRemoveImg (index) {
      let that = this
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let img = that.currentRow.materialPhotoList[index]
        that.axios.post('materialPhoto/deleteById', that.qs.stringify({ id: img.id })).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功！')
            that.getMaterial()
            that.currentRow.materialPhotoList.splice(index, 1)
            that.srcList.splice(index, 1)
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    onModifyMaterial (key, row, notRefresh, flag) {
      let params = null
      if (row) {
        params = {
          id: row.id,
          [key]: row[key]
        }
      } else {
        params = {
          id: this.currentRow.id,
          [key]: this.currentRow[key]
        }
      }
      this.axios.post('material/modify', params).then(res => {
        if (res.data.success) {
          if (flag === 1) {
            if (row[key] === 1) {
              this.$message.success('发布成功')
            } else {
              this.$message.success('取消发布成功')
            }
          } else {
            this.$message.success('修改成功')
          }
          if (!notRefresh) {
            this.getMaterial(false)
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onDeleteMaterial () {
      let priceArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      let that = this
      for (let i = 0; i < priceArr.length; i++) {
        idArr.push(priceArr[i].id)
        nameArr.push(priceArr[i].name)
      }
      if (idArr.length === 0) {
        that.$message({
          type: 'warning',
          message: '请先选择您要删除数据'
        })
        return
      }
      this.$confirm(`此操作将永久删除"${nameArr.join('、')}", 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('material/deleteByIds', that.qs.stringify({ ids: idArr.join(',') })).then(res => {
          if (res.data.success) {
            that.$message.success('删除成功')
            this.$refs.erpTable.setAllSelection(false)
            that.getMaterial(true)
          } else {
            that.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    httpRequestImg (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('fileData', e.file)
      formData.append('type', 3)
      formData.append('description', '')
      let that = this
      this.axios.post(`${this.$store.state.API_URL_9009}/fileUpload/uploadFile`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        let params = {
          path: onloadRes.data.data.path,
          materialId: that.currentRow.id
        }
        this.axios.post('materialPhoto/save', params).then(res => {
          if (res.data.success) {
            this.$message.success('上传成功！')
            this.getMaterial()
            that.currentRow.materialPhotoList.push({
              completePath: res.data.data.completePath,
              materialId: that.currentRow.id,
              name: '',
              id: res.data.data.id
            })
            that.srcList.push(res.data.data.completePath)
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message.error('上传失败！')
      })
    },
    onSearch () {
      this.page = 1
      this.isClassifyShow = false
      // this.chooseMenuId = 0
      this.getClassify()
      this.getMaterial()
    },
    jump (page) { // 分页
      this.page = page.pageNo
      this.limit = page.pageTotal
      this.getMaterial()
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
        this.page = 1
        this.isClassifyShow = true
        this.keywords = ''
        this.getMaterial(true)
      }
    },
    getMaterial (isRefresh) {
      this.tableData = []
      this.loading = true
      let params = {
        page: this.page,
        limit: this.limit,
        keywords: this.keywords,
        companyId: this.$store.state.companyId,
        searchAll: 1
      }
      if (this.isClassifyShow) {
        params.classifyId = this.chooseMenuId
      }
      this.axios.post(`material/queryForPage`, params).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.list
          if (isRefresh) {
            this.currentRow = {}
          }
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].status === 1) {
              this.tableData[i].unEditable = 'ALL'
            }
          }
          if (this.tableData.length > 0 && isRefresh) {
            this.currentRow = this.tableData[0]
            this.srcList = []
            if (this.currentRow.materialPhotoList !== null) {
              for (let i = 0; i < this.currentRow.materialPhotoList.length; i++) {
                this.srcList.push(this.currentRow.materialPhotoList[i].completePath)
              }
            }
          }
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
        this.loading = false
      })
    },
    getClassify (isRefresh) {
      this.classifyList = []
      this.axios.post(`materialClassify/findAllClassify`, { companyId: this.$store.state.companyId }).then(res => {
        if (res.data.success) {
          this.classifyList = res.data.data
          if (isRefresh) {
            this.getDefaultId(this.classifyList)
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getDefaultId (list) {
      if (list && list.length) {
        let classify = list[0]
        // if (classify.children && classify.children.length) {
        //   this.getDefaultId(classify.children)
        // } else {
        this.chooseMenuId = classify.id
        this.currentClassify = classify
        this.getMaterial(true)
        // }
      }
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.srcList = []
      for (let i = 0; i < this.currentRow.materialPhotoList.length; i++) {
        this.srcList.push(this.currentRow.materialPhotoList[i].completePath)
      }
    },
    switchSmallTab (index) {
      this.smallTabIndex = index
    },
    toBigImg () {
      this.isErcodeShow = true
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.getMaterial()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-half-left {
  flex: 1;
  background: #ffffff;
  height: 100%;
  border-right: 1px dashed #e2e2e2;
  display: flex;
  flex-direction: column;

  .dialog-menu-item {
    height: 35px;
    line-height: 35px;
    display: flex;
    padding: 0 20px;
    font-size: 12px;
    color: #30313a;
    text-align: left;
    cursor: pointer;

    &.active {
      color: #46b8b0;
    }

    &.current {
      color: #46b8b0;
      background: #f3f4f7;
    }
  }
}

.dialog-half-right {
  flex: 1;
  background: #f3f4f7;
  display: flex;
  flex-direction: column;
}

.qr-item {
  width: calc((100% / 3) - 20px);
  margin: 0 10px 20px;
  background-color: #f3f4f7;
  padding: 20px;
  display: flex;
  position: relative;
}

.delete-img {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 16px;
  color: #ff5555;
  cursor: pointer;
}

.left-top {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  border-bottom: 1px solid #e2e2e2;
  height: 40px;
  text-align: left;
  cursor: pointer;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #46b8b0;
  border-radius: 4px;
}

.decoration-line-hui {
  width: 4px;
  height: 16px;
  background-color: #e2e2e2;
  border-radius: 4px;
}

.content-top {
  height: 30px;

  .tab-item {
    font-size: 16px;
    color: #272727;
    display: flex;
    align-items: center;
    margin-right: 15px;
    cursor: pointer;

    span {
      height: 16px;
    }

    &.active {
      color: #46b8b0;
    }
  }
}

.el-icon-zoom-in {
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  color: #30313a;
}

.font-13-46b8b0 {
  font-size: 13px;
  color: #46b8b0;
}

.el-card {
  height: 90px;
  border: 1px solid #e2e2e2;
  cursor: pointer;
}

.info-item {
  width: 198px;
  border-bottom: 1px solid #e2e2e2;
  display: flex;
  align-items: center;
  margin-top: 10px;
  font-size: 12px;
  color: #30313a;
  margin-right: 30px;
  line-height: 20px;
  height: 20px;
}

.modify-dialog-left {
  width: 125px;
  border-right: 1px solid #e2e2e2;

  .modify-item {
    padding: 0 20px;
    height: 35px;
    line-height: 35px;
    border-bottom: 1px dashed #e2e2e2;
    font-size: 14px;
    color: #30313a;
    text-align: left;
    cursor: pointer;

    &.active {
      color: #46b8b0;
      background-color: #f3f4f7;

      span {
        position: relative;

        &:after {
          width: 100%;
          content: '';
          height: 2px;
          position: absolute;
          background-color: #46b8b0;
          left: 0;
          bottom: -10px;
        }
      }
    }
  }
}

.require-tip {
  position: absolute;
  left: -10px;
  color: #ff5555;
  top: 10px;
}

.tabActive {
  position: relative;

  &:after {
    position: absolute;
    content: '';
    width: 100%;
    height: 1px;
    background-color: #46b8b0;
    left: 0;
    bottom: 0;
  }
}

.search {
  overflow: hidden;
}

.search /deep/.el-input__inner {
  padding-left: 0;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/systemDefine/materialDefine.vue